import { graphql } from "../generated";
export const MUTATE_DELETE_THREAD = graphql(`
  mutation MutateDeleteThread($id: Int!) {
    deleteThread(id: $id)
  }
`);
